import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.content}/v4/modules`, {
  get: {
    'module.get': '/:id',
    'module.getAll': '/',
    'module.getPages': '/:id/pages',
    'module.firstModulePaid': '/firstModulePaid',
    'duplication.candidates': '/:id/pages/duplication-candidates'
  },
  post: {
    'module.create': '/',
    'module.sort': '/:id/order'
  },
  put: {
    'module.update': '/:id',
    'module.rename': '/:id/name'
  },
  delete: {
    'module.delete': '/:id'
  }
});

Request.register(`${Settings.api.content}/v4/pages`, {
  get: {
    'page.get': '/:pageId'
  },
  post: {
    'page.sort': '/:id/order',
    'page.create': ''
  },
  put: {
    'page.rename': '/:id/name',
    'page.publish': '/published',
    'page.update': '/:pageId'
  }
});

Request.register(`${Settings.api.content}/v4/membershipClass`, {
  get: {
    'class.get': '/'
  }
});

Request.register(`${Settings.api.content}/v4/tags`, {
  get: {
    'tags.suggestions': '/'
  }
});

Request.register(`${Settings.api.content}/v4/searchArticleInfo`, {
  post: {
    'article.get': '/'
  }
});

Request.register(`${Settings.api.content}/v4/seasons`, {
  get: {
    'seasons.getAll': '/'
  }
});

Request.register(`${Settings.api.content}/v4/preview`, {
  get: {
    'preview.get': '/'
  }
});

Request.register(`${Settings.api.content}/v4/content/deleted`, {
  put: {
    'mass.delete': '/'
  }
});

Request.register(`${Settings.api.content}/v4/certificates`, {
  get: {
    'certificates.get': '/'
  }
});

Request.register(`${Settings.api.userprofile}`, {
  get: {
    'get.userprofile.languages': '/language'
  }
});

Request.register(`${Settings.api.content}/v1/content-duplication`, {
  post: {
    'duplicate.module': '/module',
    'duplicate.page': '/page'
  }
});
